import React from 'react';

import HeaderTopic from '../../partials/HeaderTopic';
import BasicButtons from '../../partials/BasicButtons';

import styles from './NewPassAsk.module.css';
import PrimaryButton from '../../partials/PrimaryButton';
import { getSmsRenewPass } from '../../api/getSmsRenewPass';

function NewPass(props) {
  const { user, refreshStates } = props;
  const [cell, setCell] = React.useState("");
  const [errorMsg, setErrorMsg] = React.useState("");

  const handleSubmit = async () => {
    if (cell.length !== 10) {
      setErrorMsg("אורך מספר הנייד אינו תקין");
    } else if (cell[0] !== "0") {
      setErrorMsg("מספר נייד לא תקין");
     } else {
       setErrorMsg("מחדש את הססמה");
      const res = await getSmsRenewPass(cell);
      if (res.error) {
        setErrorMsg("ישנה תקנה - אנא נסו שוב עוד כמה דקות");
      } else {
        setErrorMsg(
          "הודעת סמס עם לינק שחזור סיסמה נשלחה אל הנייד שלך - יש להקליק על הקישור לשחזור הסיסמה"
        );
      }
    }
  };

  return (
    <div className={styles.newPassAsk}>
      <HeaderTopic topic="חידוש סיסמה" />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <form>
        <input
          type="tel"
          value={cell}
          placeholder="מספר נייד לקבלת קוד"
          onChange={(e) => setCell(e.target.value)}
        />

        <span className={styles.error}>{errorMsg}</span>

        <PrimaryButton type="button" text={'   קבלת לינק לחידוש סיסמה'}  size={'large'} onClick={handleSubmit}>

        </PrimaryButton>
      </form>
    </div>
  );
}

export default NewPass;
